import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as chatwork from '@libs/chatwork'
import * as requestPostManager from '@managers/requestPostManager'
import * as logManager from '@managers/logManager'
import { TASK_REQUEST_FEATURES } from '@/config'

const TASKS_TYPE ='task_request'
const TASK_REQUEST_ORDER_COLLECTION_NAME ='task_request_order'

const TASK_MST ='task_master'
const TASK_SET_MST ='task_request_set_master'

export const TaskRequestSchema = {
  requestPostId: '',
  taskRequestRequestNo: '',
  subTaskNo: '',
  requestTask: '',
  departmentId: '',
  departmentName: '',
  toStaffId: '',
  toStaffName: '',
  limitDate: '',
  owner: '',
  commission: '',
  finishPoint: '0',
  finishYear: null,
  finishMonth: null,
  estimationCleanCategory: [],
  estimationInspectCategory: [],
  estimationOtherCategory: [],
  finalCompletionTask: '',
  allCopy: false,
  displayOrder: 0,
  details: []
}

export const OrderTaskRequestSchema = {
  estimateNo: '',
  subTaskNo: '',
  requestTask: '',
  departmentId: '',
  departmentName: '',
  toStaffId: '',
  toStaffName: '',
  limitDate: '',
  finalCompletionTask: '',
  displayOrder: 0,
  details: []
}

/**
 *  タスク依頼 取得(リクエストポストIDを条件に全件取得)
 */
export async function getByRequestPostId(context, requestPostId, status) {
  const searchCondition = {
    searchCondition: {
      type: TASKS_TYPE,
      status: { $ne: "remove" },
      requestPostId,
    },
    sort: {
      displayOrder: 1
    }
  }
  // 削除済みの場合
  if (status && status == 'remove') {
    delete searchCondition.searchCondition.status
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData || null
    return allocation
  } catch (error) {
    console.log('getByRequestPostId error !!!')
    console.log(error)
    return null
  }
}

/**
 * タスク依頼 _id 取得
 * @param {*} context
 * @param {*} _id
 * @returns
 */

export async function get(context, _id) {
  const searchCondition = {
    searchCondition: {
      type: TASKS_TYPE,
      _id
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData[0] || null
    return allocation
  } catch (error) {
    console.log('getRequest error !!!')
    console.log(error)
    return null
  }
}

/**
 * タスク依頼取得（リクエストポストID、statusでの絞込み）
 * @param {*} context
 * @param {*} requestPostIds リクエストポストID 配列
 * @param {*} status ステータス
 * @param {*} wording キーワード（部分一致）
 * @returns
 */
export async function getByRequestPostIdAndStatus(context, requestPostIds, status, wording) {
  const searchCondition = {
    searchCondition: {
      type: TASKS_TYPE,
      status: status,
      requestTask: { $regex: wording },
      requestPostId: { $in: requestPostIds }
    },
    sort: {
      limitDate: 1
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData || null
    return allocation
  } catch (error) {
    console.log('getByRequestPostIdAndStatus error !!!')
    console.log(error)
    return null
  }
}

/**
 * タスク依頼 登録
 */
export async function register(context, target, cwCooperation) {
  try {

    const subTaskNo = await createSubTaskNo(context, target)
    target.subTaskNo = subTaskNo
    const registrationData = createRegistrationData(target)
    console.log('registrationData : ')
    console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    let result = await context.$pigeon.registerTask(TASKS_TYPE, registrationData, q)

    return result._id
  } catch (error) {
    console.log('register error !!!')
    console.log(error)
    return false
  }
}

/**
 * サブタスク番号生成
 * @param {*} context
 * @param {*} target データ
 * @returns
 */
async function createSubTaskNo(context, target) {
  const res = await context.$pigeon.getAutomaticNumber(
    TASKS_TYPE,
    'subTaskNo',
    'rp_sub_task_no_setting',
    target
  )
  return res
}

/**
 * 更新
 * @param {*} context
 * @param {*} target
 * @param {*} cwCooperation
 * @returns
 */
export async function update(context, target, cwCooperation) {
  try {
    const registrationData = createRegistrationData(target)
    registrationData.type = TASKS_TYPE
    console.log('registrationData : ')
    console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    await context.$pigeon.updateTask(registrationData._id, registrationData, q)

    return true
  } catch (error) {
    console.log('update error !!!')
    console.log(error)
    return false
  }
}

/**
 * タスク削除
 */
export async function deleteTask(context, id) {
  try {
    await context.$pigeon.deleteTask(id)
    return true
  } catch (error) {
    console.log('deleteTask error !!!')
    console.log(error)
    return false
  }
}

/**
 * タスク物理削除
 */
export async function deleteTask2(context, subTaskNo) {
  try {
    const deleteCondition = {
      type: TASKS_TYPE,
      subTaskNo
    }
    await context.$pigeon.generalDelete('Tasks', deleteCondition)
    return true
  } catch (error) {
    console.log('deleteTask2 error !!!')
    console.log(error)
    return false
  }
}

/**
 * 新規タスク依頼生成
 * @returns
 */
export function create() {
  const newTaskRequest = { ...utils.clone(TaskRequestSchema) }
  return newTaskRequest
}

// /**
//  * 更新
//  * @param {*} context
//  * @param {*} org
//  * @param {*} target
//  * @returns
//  */
// export async function updateDispatchDate(context, org, target) {

//   if (!org._id) {
//     console.log('IDが指定されていません。')
//     return false
//   }

//   const updateData = {
//     type: TASKS_TYPE,
//     target
//   }

//   try {
//     await context.$pigeon.updateTask(org._id, updateData, {})
//     return true
//   } catch (error) {
//     console.log('updateLeasePeriod error !!!')
//     console.log(error)
//     return false
//   }
// }

/**
 * 登録データ 生成
 */
function createRegistrationData(target) {
  const registrationData = utils.clone(target)
  return registrationData
}

/**
 * タスク依頼検索
 * @param {*} context
 * @param {*} searchKeys
 * @param {*} keyword
 * @param {*} status
 * @param {*} periodKey
 * @param {*} period
 * @returns
 */
export async function searchTaskRequests(context, searchKeys, keyword, status, periodKey, period) {
  console.log('searchTaskRequests')
  console.log(keyword)
  console.log(status)

  const searchCondition = {
    searchCondition: {
      type: TASKS_TYPE,
      status: { $ne: "remove" }
    },
    sort: {
      createDate: -1
    }
  }

  if (periodKey && period) {
    searchCondition.searchCondition[periodKey] = {}
    if (period.start) {
      searchCondition.searchCondition[periodKey].$gte = period.start + ' 00:00:00'
    }
    if (period.end) {
      searchCondition.searchCondition[periodKey].$lte = period.end + ' 23:59:59'
    }
    if (Object.keys(searchCondition.searchCondition[periodKey]).length === 0) {
      delete searchCondition.searchCondition[periodKey]
    }
    // {
    //   $gte: period.start,
    //   $lte: period.end
    // }
  }

  const keywordCondition = buildMultipleKeywordSearchCondition(keyword || '', searchKeys|| [])
  if (keywordCondition) {
    searchCondition.searchCondition = { ...searchCondition.searchCondition, ...keywordCondition } //.$and = keywordCondition
  }

  // if (selectFields) {
  //   searchCondition.selectFields = selectFields
  // }

  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const searchTaskRequests = responseData || []
    return searchTaskRequests
  } catch (error) {
    console.log('searchTaskRequests error !!!')
    console.log(error)
    return []
  }
}

function buildMultipleKeywordSearchCondition(keywordText, searchKeys) {
  keywordText = keywordText.trim()
  if (keywordText === '') {
    return null
  } else {
    const keywords = keywordText.split(/\s+/g)
    const condition = { $and: [] }
    keywords.forEach(function(keyword) {
      const query = { $or: [] }
      searchKeys.forEach(function(searchKey) {
        const expression = {}
        expression[searchKey] = { $regex: keyword, $options: 'i'}
        query.$or.push(expression)
      });
      condition.$and.push(query);
    });
    return condition;
  }
}

/**
 * ステータスをdoneにする
 * @param {*} context
 * @param {*} id タスクID
 * @returns
 */
export async function statusDone(context, id) {
  try {
    await context.$pigeon.completeTask(id)
    return true
  } catch (error) {
    console.log('statusDone error !!!')
    console.log(error)
    return false
  }
}

/**
 * ステータスをopenにする
 * @param {*} context
 * @param {*} id タスクID
 * @returns
 */
export async function statusOpen(context, id) {
  try {
    await context.$pigeon.incompleteTask(id)
    return true
  } catch (error) {
    console.log('statusOpen error !!!')
    console.log(error)
    return false
  }
}

/**
 * 新規受注タスク依頼 生成
 * @returns
 */
 export function newOrderTaskRequestCreate() {
  const newOrderTaskRequest = { ...utils.clone(OrderTaskRequestSchema) }
  return newOrderTaskRequest
}

/**
 * 受注タスク依頼 登録
 */
 export async function orderTaskRequestRegister(context, target, cwCooperation) {
  try {
    const subTaskNo = await createOrderSubTaskNo(context, target)
    target.subTaskNo = subTaskNo
    const registrationData = createRegistrationData(target)
    console.log('registrationData : ')
    console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    await context.$pigeon.registerTask(TASK_REQUEST_ORDER_COLLECTION_NAME, registrationData, q)

    return true
  } catch (error) {
    console.log('register error !!!')
    console.log(error)
    return false
  }
}

/**
 * 受注タスク依頼 更新
 * @param {*} context
 * @param {*} target
 * @param {*} cwCooperation
 * @returns
 */
 export async function orderTaskRequestUpdate(context, target, cwCooperation) {
  try {
    const registrationData = createRegistrationData(target)
    registrationData.type = TASK_REQUEST_ORDER_COLLECTION_NAME
    console.log('registrationData : ')
    console.log(registrationData)

    const q = {}
    if (cwCooperation === true) {
      q.cwCooperation = 'cw-on'
    } else if (cwCooperation === false) {
      q.cwCooperation = 'cw-off'
    }

    await context.$pigeon.updateTask(registrationData._id, registrationData, q)

    return true
  } catch (error) {
    console.log('update error !!!')
    console.log(error)
    return false
  }
}

/**
 *  受注タスク依頼 取得(受注IDを条件に全件取得)
 */
export async function getByOrderId(context, orderId, status) {
  const searchCondition = {
    searchCondition: {
      type: TASK_REQUEST_ORDER_COLLECTION_NAME,
      status: { $ne: "remove" },
      orderId,
    },
    sort: {
      displayOrder: 1
    }
  }
  // 削除済みの場合
  if (status && status == 'remove') {
    delete searchCondition.searchCondition.status
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const allocation = responseData || null
    return allocation
  } catch (error) {
    console.log('getByRequestPostId error !!!')
    console.log(error)
    return null
  }
}

/**
 * 受注サブタスク番号生成
 * @param {*} context
 * @param {*} target データ
 * @returns
 */
async function createOrderSubTaskNo(context, target) {
  const res = await context.$pigeon.getAutomaticNumber(
    TASK_REQUEST_ORDER_COLLECTION_NAME,
    'subTaskNo',
    'order_sub_task_no_setting',
    target
  )
  return res
}

/**
 * 受注タスク物理削除
 */
export async function orderTaskRequestDeleteTask(context, subTaskNo) {
  try {
    const deleteCondition = {
      type: TASK_REQUEST_ORDER_COLLECTION_NAME,
      subTaskNo
    }
    await context.$pigeon.generalDelete('Tasks', deleteCondition)
    return true
  } catch (error) {
    console.log('deleteEstimate error !!!')
    console.log(error)
    return false
  }
}

/**
 * サブタスク登録時にpostgresに「提出」サブタスクの完了日を保存
 * @param {*} task サブタスク
 * @param insertUser 更新者
 * @param subtask サブタスクすべて
 */
export async function saveEstimateSubmission(task, insertUser, subtask) {
  // postgresに登録
  let res
  // サブタスクが配列の場合
  if (Array.isArray(task)) {
    // 違うサブに見積作成がある場合のみ
    const isEstimate = task.find((t) => {
      return t.requestTask.indexOf('見積作成') > -1
    })
    if (isEstimate && isEstimate.requestTask) {
      res = await backend.postData('estimateSubmission/saveArry', { task, insertUser })
      if (!res || res.data == 'Internal Server Error') {
        alert('エラーが発生しました。estimateSubmission/save')
      }
    }
  } else {
    // 違うサブに見積作成がある場合のみ
    const isEstimate = subtask.find((t) => {
      return t.requestTask.indexOf('見積作成') > -1
    })
    if (isEstimate && isEstimate.requestTask) {
      res = await backend.postData('estimateSubmission/saveObject', { task, insertUser})
      if (!res || res.data == 'Internal Server Error') {
        alert('エラーが発生しました。estimateSubmission/save')
      }
    }
  }
}

/**
 * サブタスクマスタにセットされている部署と担当者のID等を取得
 * @param {*} subMst サブマスタ
 * @param {*} task タスク
 * @param {*} mainDepartment メイン部署
 * @param {*} mainDepartmentId メイン部署ID
 * @param {*} mainToUser メイン担当
 * @param {*} mainByUser メイン依頼主
 * @param {*} departmentList 部署リスト
 * @param {*} userDepartment ログインユーザー所属部署
 * @param {*} loginUser ログインユーザー情報
 */
export async function setSubCharge(subMst, task, mainDepartment, mainDepartmentId, mainToUserId, mainToUser, mainByUserId, mainByUser, departmentList, userDepartment, loginUser) {
  let departmentName = ''
  let toStaffName = ''

  if (!subMst) {
    return
  }

  // メイン担当者と同じ
  if (subMst.sameToUser) {
    task.departmentName = mainDepartment
    task.departmentId = mainDepartmentId
    task.toStaffId = mainToUserId
    task.toStaffName = mainToUser

  // メイン依頼主と同じ
  } else if (subMst.sameByUser) {
    task.toStaffId = mainByUserId
    task.toStaffName = mainByUser

    // 依頼主がログインユーザーと同じ
    if (mainByUserId == loginUser.mstUserId) {
      task.departmentName = loginUser.departmentName
      task.departmentId = loginUser.departmentIdUser
    } else {
      // ユーザーIDからメインとなる部署を取得
      const res = await backend.searchData('userDepartment/getMainDepartment', { userId: mainByUserId })
      if (res.data.data && res.data.data[0]) {
        task.departmentName = res.data.data[0].departmentName
        task.departmentId = res.data.data[0].departmentId
      }
    }

  } else {
    // メイン依頼先部署によって担当が違う場合
    if (subMst.byMainDepartment) {
      let dep = subMst.charge.find((s) => {
        return s.mainDepartmentName == mainDepartment
      })
      // 対象のデータがない場合
      if (!dep || !dep.departmentName) {
        dep = subMst.charge.find((s) => {
          return s.mainDepartmentName == '他全て'
        })
      }
      if (dep) {
        departmentName = dep.departmentName
        toStaffName = dep.toStaffName
      }

    } else {
      departmentName = subMst.departmentName
      toStaffName = subMst.toStaffName
    }

    // 部署名が設定されている場合
    if (departmentName) {
      // 現在の部署に同じ部署名がある場合、部署名・部署IDをセット
      let dep = departmentList.find((r) => {
        return (r.name == departmentName)
      })
      if (dep) {
        task.departmentName = dep.name
        task.departmentId = dep.departmentId
      }
    }

    // 担当者名が設定されており、部署がセットされている場合
    if (toStaffName && task.departmentId) {
      // 該当の部署に同じ担当者がいる場合
      let staff = userDepartment.find((ud) => {
        return (ud.departmentId == task.departmentId && ud.userName == toStaffName)
      })
      if (staff) {
        task.toStaffId = staff.userId
        task.toStaffName = staff.userName
      }
    }
  }

  // 非公開で使用
  task.toStaffValue = {
    value: task.toStaffId,
    text: task.toStaffName
  }
}

/**
 * サブの期限をセット
 * @param {*} task サブタスク
 * @param {*} subMst サブタスクマスタ
 * @param {*} requestPost メインデータ
 */
export function setSubLimitDate(task, subMst, requestPost) {
  // 期限が設定されている場合
  if (subMst && subMst.limit) {
    let addType = 'days'
    if (subMst.limitMonthCount) {
      addType = 'months'
    }
    let limit = moment().add(Number(subMst.limit), addType).format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')

    // 期限の対象日が設定されている場合
    if (subMst.limitTarget) {
      let tar = requestPost[subMst.limitTarget]
      // console.log(tar)
      if (tar) {
        tar += ' 00:00:00'
        limit = moment(tar).add(Number(subMst.limit), addType).format('YYYY-MM-DD')
      } else {
        limit = ''
      }
    }

    // 期限がすでに過去日になっている場合
    if (limit < today) {
      // 翌営業日にする
      let nextDay = utils.getNextBusinessDay()
      limit = moment(nextDay).format('YYYY-MM-DD')
    }

    // メインの期限>=サブの期限の場合
    if (limit && requestPost.limitDate >= limit) {
      task.limitDate = limit
    // メインの期限が本日以降
    } else if (limit && requestPost.limitDate >= today) {
      task.limitDate = requestPost.limitDate
    }
  }
}

/**
 * サブタスクチャット送信反映
 * @param {*} main メインタスクデータ
 * @returns
 */
export function isSendChatWorkSubTask(main) {
  // チャット送信設定値
  const feature = TASK_REQUEST_FEATURES.TASK_REQUEST.SEND_CHATWORK_MESSAGE_WHEN_REQUESTING_TASKS

  // 設定がOFF、もしくは雇入れの場合
  if (!feature || !feature.enable || (main.category && main.category[0].includes('雇い入れ'))) {
    return false
  }

  return true
}

/**
 * チャット送信する場合、そのまま送信
 * @param {*} context
 * @param {*} main
 * @param {*} sub
 * @returns
 */
export async function isSendChatWorkSubTaskAndSend(context, main, sub) {
  // 送信OFF、雇入れは送信しない
  if (!isSendChatWorkSubTask(main)) return false

  // メイン担当者
  const mainStaff = utils.deleteKana(main.toStaffName)

  // サブ担当者
  let subStaff = utils.deleteKana(sub.toStaffName)
  let subStaffId = sub.toStaffId

  // RP担当者とサブタスク担当者が同じ場合はチャットは送信しない（サブタスク担当者が未定の場合は対象外）
  if (mainStaff.replace(/\s+/g, '') == subStaff.replace(/\s+/g, '') && subStaff != '未定') return false

  // チャット送信設定値
  const feature = TASK_REQUEST_FEATURES.TASK_REQUEST.SEND_CHATWORK_MESSAGE_WHEN_REQUESTING_TASKS
  await sendChat(feature.messageTemplate, sub, null, subStaffId, subStaff, [], [], context.$store.getters.user.user_name, false, main)
  return true
}

/**
 * チャット送信
 * @param task 対象タスク
 * @param changeMsg 変更内容
 * @param staffId 送信先スタッフID
 * @param staff 送信先スタッフ名
 * @param noRoomId ルームID無しで送信不可リスト
 * @param noToken トークン無しで送信不可リスト
 * @param {*} loginUser ログインユーザー
 * @param {*} isOrder 受注タスクか否か
 * @param {*} requestPost メインタスク
 * @returns
 */
export async function sendChat(temp, task, changeMsg, staffId, staff, noRoomId, noToken, loginUser, isOrder, requestPost) {
  // URL生成
  let viewUrl = ''
  // メインが受注の場合
  if (isOrder) {
    viewUrl= `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}taskRequest?orderId=${requestPost._id}&mode=1`
    temp = temp.replace('サブタスク', 'サブタスク【受注】')

  // メインがRPの場合
  } else {
    viewUrl = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}taskRequest?requestPostId=${requestPost._id}`
  }

  // チャット情報を取得
  const result = await backend.searchData('user/getAllDataByUser', {day: utils.getToday(), userId: staffId})
  const chat = result.data.data

  // roomIdなし
  if (!chat.chatworkRoomId) {
    noRoomId.push(staff + 'さん')
    return { noRoomId, noToken }
  // tokenなし
  } else if (!chat.chatworkApiTokenDepartment) {
    noToken.push(staff + 'さん')
    return { noRoomId, noToken }
  }

  let mension = ''
  if (staff == '未定') {
    mension = '[toall] 未定さん'
  } else if (chat.chatworkAccountId && chat.chatworkAccountId != '') {
    mension = `[To:${chat.chatworkAccountId}]${staff}さん`
  } else {
    mension = `[To]${staff}さん`
  }

  let changedDetails = ''
  // 変更内容がある場合
  if (changeMsg && changeMsg.length) {
    changedDetails = changeMsg.join('、\r\n') + 'に変更されました。'
  }

  const context = {
    mension,
    requestTask: task.requestTask, // タスク名
    limitDate: task.limitDate,
    inquiry_title: requestPost.inquiry_title, // メインタスクのタイトル
    sender: loginUser,
    loginUser,
    viewUrl,
    changedDetails
  }

  // 非公開依頼の場合、URL削除
  if (requestPost.category.includes('非公開依頼')) {
    temp = temp.replace('● サブタスク：${viewUrl}', '')
    context.requestTask = '※非公開のため詳細非表示'
    context.inquiry_title = '※非公開のため詳細非表示'
  }

  // チャットタスク内容生成
  let expression = '`' + temp + '`'

  // 社員の面接の場合、タイトル変更
  if (requestPost.category.includes('面接関連') && requestPost.interviewsRegularStaff) {
    let inte = ''
    if (requestPost.interviewsResult && requestPost.interviewsResult[0]) {
      inte = `（${requestPost.interviewsResult[0]}）`
    }
    context.inquiry_title = '※社員面接のため詳細非表示' + inte
  }

  const sendMessage = utils.evaluate(context, expression)
  // console.log(sendMessage)

  if (chat && chat.chatworkRoomId && chat.chatworkApiToken) {
    await chatwork.sendChatWorkMssage(
      chat.chatworkRoomId,
      sendMessage,
      chat.chatworkApiToken
    )
  }
  return { noRoomId, noToken }
}

/**
 * ステータスを完了
 * @param {*} s
 */
export function changeStatusDone(s, userName) {
  if (s.status == 'open') {
    s.status = 'done'
    s.doneDate = moment().format('YYYY-MM-DD HH:mm:ss')
    s.doneStaffName = userName
  }
  return s
}

/**
 * 受注でないサブタスクを完了した際に、メインも完了
 * @param {*} sub サブタスク（配列）
 */
export async function updateMainForAllSubDone(context, sub) {
  // サブが全て完了したか確認
  let flag = false
  for (let i = 0; i < sub.length; i++) {
    const t = sub[i]
    // 新規のサブもしくは未完了のサブ
    if (!t.status || (t.status && t.status == 'open')) {
      flag = true
      break
    }
  }
  // 全て完了した場合
  if (!flag && sub.length) {
    const result = await requestPostManager.markAsDone(context, sub[0].requestPostId)

    if (result) {
      logManager.recording(context, logManager.Loglevel.INFO, 'メインタスク', 'ステータス完了', 'メインタスク（お問い合わせ番号：' + sub[0].taskRequestRequestNo + '）のステータスを完了しました。\r\n（見積書メール自動送信にて完了）')
    }
  }
}

/**
 * メインタスクのステータスのみ 取得
 * @param {*} context
 * @param {*} _id
 * @returns
 */

export async function getMainStatus(context, mainType, mainId) {
  const searchCondition = {
    searchCondition: {
      type: mainType,
      _id: mainId
    },
    selectFields: ['status']
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const res = responseData[0] || null
    return res
  } catch (error) {
    console.log('getMainStatus error !!!')
    console.log(error)
    return null
  }
}

/**
 * サブタスクマスタ取得
 * @param {*} context
 * @returns
 */
export async function getTaskMst(context) {
  const searchCondition = {
    searchCondition: {
      type: TASK_MST,
      status: { $ne: 'remove' }
    },
    sort: {
      category: 1,
      task: 1
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const res = responseData || null
    return res
  } catch (error) {
    console.log('getTaskMst error !!!')
    console.log(error)
    return null
  }
}

/**
 * サブタスクマスタをセッションストレージを優先的に取得
 * @param {*} context
 * @returns
 */
export async function getTaskMstByStorage(context) {
  let data = []
  // ストレージに保存済みであればそれから取得
  data = sessionStorage.getItem('subTaskMst')

  if (data && data.length) {
    return JSON.parse(data)
  }

  // なければ取得
  data = await getTaskMst(context)

  // ストレージに保存
  if (data && data.length) {
    sessionStorage.setItem('subTaskMst', JSON.stringify(data))
    return data
  }
  return []
}

/**
 * メインのカテゴリーに関係あるサブタスクマスタ取得
 * @param {*} context
 * @param {*} categoryArr メインタスクのカテゴリー
 * @returns
 */
export async function getTaskMstByCategory(context, categoryArr) {
  let data = []
  // サブマスタ全部取得
  data = await getTaskMstByStorage(context)

  if (data && data.length && categoryArr && categoryArr.length) {
    // 業務依頼が含まれている場合は全て
    if (categoryArr.includes('業務依頼')) {
      return data
    }

    // サブタスクマスタの中にメインのカテゴリーと同じものがあれば取得
    return data.filter(mst =>
      mst.category?.some(c => categoryArr.includes(c))
    )
  }
  return []
}

/**
 * サブタスクSETマスタ取得
 * @param {*} context
 * @returns
 */
export async function getTaskSetMst(context) {
  const searchCondition = {
    searchCondition: {
      type: TASK_SET_MST,
      status: { $ne: 'remove' }
    },
    sort: {
      category: 1,
      name: 1
    }
  }
  try {
    const responseData = await context.$pigeon.searchTasks(searchCondition)
    const res = responseData || null
    return res
  } catch (error) {
    console.log('getTaskMst error !!!')
    console.log(error)
    return null
  }
}

/**
 * サブタスクセットマスタをセッションストレージを優先的に取得
 * @param {*} context
 * @returns
 */
export async function getTaskSetMstByStorage(context) {
  let data = []
  // ストレージに保存済みであればそれから取得
  data = sessionStorage.getItem('subTaskSetMst')

  if (data && data.length) {
    return JSON.parse(data)
  }

  // なければ取得
  data = await getTaskSetMst(context)

  // ストレージに保存
  if (data && data.length) {
    sessionStorage.setItem('subTaskSetMst', JSON.stringify(data))
    return data
  }
  return []
}

/**
 * メインのカテゴリーに関係あるサブタスクセットマスタ取得
 * @param {*} context
 * @param {*} categoryArr メインタスクのカテゴリー
 * @returns
 */
export async function getTaskSetMstByCategory(context, categoryArr) {
  let data = []
  // サブセットマスタ全部取得
  data = await getTaskSetMstByStorage(context)

  if (data && data.length && categoryArr && categoryArr.length) {
    // 業務依頼が含まれている場合は全て
    if (categoryArr.includes('業務依頼')) {
      return data
    }

    // サブタスクマスタの中にメインのカテゴリーと同じものがあれば取得
    const d = data.filter(mst =>
      mst.category?.some(c => categoryArr.includes(c))
    )
    return d
  }
  return []
}

/**
 * 雇い入れ自動登録にてサブタスクも自動保存
 * @param {*} context
 * @param {*} requestPostId メインタスクID
 * @param {*} main メインタスク情報
 */
export async function autoEmploySubTaskSave(context, requestPostId, main) {
  const cat = '雇い入れ'
  let tar = '新規入社'
  if (main.employmentClass && main.employmentClass[0]) {
    tar = main.employmentClass[0]
  }

  // タスクセット取得
  const setMsts = await getTaskSetMstByCategory(context, main.category)
  // 該当のセットを取得
  const setMst = setMsts.find((t) => {
    return t.name && t.name.indexOf(cat) > -1 && t.name.indexOf(tar) > -1
  })
  // サブタスクマスタ取得
  const subMsts = await getTaskMstByCategory(context, main.category)

  // ログインユーザー情報
  const user = context.$store.getters.loginUserData

  // サブタスク
  const subTasks = []

  let compFlg = false

  // 該当のサブタスクを取得
  if (setMst && setMst.group && subMsts && subMsts.length) {

    for (let i = 0; i < setMst.group.length; i++) {
      const t = setMst.group[i]
      const task = {
        requestPostId,
        taskRequestRequestNo: main.requestNo,
        subTaskNo: '',
        requestTask: t.task,
        departmentName: user.departmentName, // 初期値
        departmentId: user.departmentIdUser, // 初期値
        toStaffId: user.mstUserId, // 初期値
        toStaffName: user.userName, // 初期値
        limitDate: moment().format('YYYY-MM-DD'), // 初期値
        memo: '',
        displayOrder: i
      }

      // 該当のサブタスクマスタ
      const subMst = subMsts.find((mst) => {
        return t.task == mst.name
      })

      // 部署・担当者をマスタ設定のものを反映
      await setSubCharge(
        subMst,
        task,
        main.toDepartment,
        main.toDepartmentId,
        main.toStaffId,
        main.toStaffName,
        main.byUserId,
        main.byUser,
        context.$store.getters.departmentList,
        context.$store.getters.userDepartment,
        user
      )

      // 期限設定
      setSubLimitDate(task, subMst, main)

      // 最終完了タスク
      if (t.finalCompletionTask) {
        task.finalCompletionTask = '1'
        subTasks.forEach((sub) => {
          sub.finalCompletionTask = ''
        })
        compFlg = true
      }

      subTasks.push(task)
    }

    // 最終完了タスクがなかった場合
    if (!compFlg) {
      // 一番最後のタスクを最終タスクにする
      subTasks[subTasks.length -1].finalCompletionTask = '1'
    }

    // サブタスク保存
    for (let i = 0; i < subTasks.length; i++) {
      const s = subTasks[i]
      await register(context, s)
    }
  }
}

/**
 * 未完了のサブタスクを削除
 * @param {*} requestPostId メインタスクID
 */
export async function deleteOpenSub(context, requestPostId) {
  if (!requestPostId) {
    alert('削除できません')
    return false
  }

  // メインタスクIDに紐づくサブを取得（未完了に限る）
  const searchCondition = {
    searchCondition: {
      type: TASKS_TYPE,
      status: "open",
      requestPostId,
    },
    selectFields: ['subTaskNo']
  }
  try {
    const res = await context.$pigeon.searchTasks(searchCondition)
    if (res) {
      for (let i = 0; i < res.length; i++) {
        const r = res[i]
        // 削除
        if (r.subTaskNo) {
          await deleteTask2(context, r.subTaskNo)
        }
      }
    }
    return true
  } catch (error) {
    console.log('deleteOpenSub error !!!')
    console.log(error)
    return false
  }
}

/**
 * メインタスク登録時に登録必須サブタスクのキーワード取得
 * @param {*} main メインタスクデータ
 */
export function getRequireSubTaskKeyWord(main) {
  const cat = main.category[0]
  let tar = ''

  // 雇い入れの場合
  if (cat.indexOf('雇い入れ') > -1) {
    const ec = main.employmentClass
    if (ec && ec[0]) {
      tar = utils.clone(ec[0])
      // 退職の場合、契約変更がヒットしないようにする
      if (tar == '退職') {
        tar = '（退職）'
      } else if (tar == '契約変更') {
        // 金額のみ変更
        if (main.changeOnlyPrice) {
          tar = '金額のみ変更'
        } else if (main.modifyType == 2) {
          tar = '作業終了'
        }
      }
    }

  // 非公開依頼の場合
  } else if (cat == '非公開依頼') {
    // 始末書
    if (main.apology) {
      tar = '始末書'
    // 反省文
    } else if (main.reflect) {
      tar = '反省文'
    } else {
      tar = '-'
    }

  // デンタツの場合
  } else if (cat == 'デンタツ') {
    if (main.dentatsuCategory.includes('清掃員（退職）')) {
      tar = main.dentatsuCategory
    }
  }
  return tar
}

/**
 * サブタスク初期知設定（メインタスクデータをもとにした設定）
 * @param {*} main メインタスク
 */
export async function initSubTask(context, main, cat, tar) {
  const subTask = []
  let finalCompletionTaskFlg = false

  // サブタスク依頼セット取得（最新のセットを取得）
  sessionStorage.removeItem('subTaskSetMst');
  const taskRequestSetMasterList = await getTaskSetMstByCategory(context, main.category)

  // サブタスクマスタ取得（最新のセットを取得）
  sessionStorage.removeItem('subTaskMst');
  const taskRequestMasterList = await getTaskMstByCategory(context, main.category)

  const tasks = taskRequestSetMasterList.find((t) => {
    return t.name && t.name.indexOf(cat) > -1 && t.name.indexOf(tar) > -1
  })

  if (tasks && tasks.group && tasks.group.length) {
    for (let i = 0; i < tasks.group.length; i++) {

      const tar = taskRequestMasterList.find((t) => {
        return t.name == tasks.group[i].task
      })

      const mtask = tar

      if (mtask.name) {

        const iniStaffValue = {
          value: main.toStaffId,
          text: main.toStaffName
        }

        // 初期状態
        const task = create()
        task.requestPostId = main._id
        task.taskRequestRequestNo = main.requestNo
        task.requestTask = mtask.name
        task.departmentName = main.toDepartment
        task.departmentId = main.toDepartmentId
        task.toStaffId = main.toStaffId
        task.toStaffName = main.toStaffName
        task.limitDate = moment().format('YYYY-MM-DD')
        task.toStaffValue = iniStaffValue
        task.displayOrder = i
        task.memo = mtask.memo

        // console.log('マスタ')
        // console.log(mtask)

        // マスタにセットされている部署名、担当者をセット
        await setSubCharge(mtask, task, main.toDepartment, main.toDepartmentId, main.toStaffId, main.toStaffName, main.byUserId, main.byUser, context.$store.getters.departmentList, context.$store.getters.userDepartment, context.$store.getters.loginUserData)

        // 期限をセット
        setSubLimitDate(task, mtask, main)

        // スマイル移行後：「スマイル登録」は「雇用指示登録申請」、「スマイル入力確認」は「雇用指示承認」に変わった
        // 前は契約内容変更のときだけ担当部署・担当者を決め打ちしていた（事務センター・人事総務経理の未定）が、今はマスタの設定に従う（上の setSubCharge）

        // 最終タスク設定がされている場合
        if (mtask.finalCompletionTask) {
          subTask.forEach(s => {
            s.finalCompletionTask = ''
          });
          task.finalCompletionTask = '1'
          finalCompletionTaskFlg = true
        }

        // 詳細が設定されている場合
        if (mtask.details && mtask.details.length) {
          task.details = utils.clone(mtask.details)
        }

        subTask.push(task)
      }
    }
  }

  // 最終完了タスクがない場合
  if (subTask.length && !finalCompletionTaskFlg) {
    subTask[subTask.length - 1].finalCompletionTask = '1'
  }

  return subTask
}
